export const SearchForm = {
	selectors: {
		holder: document.querySelector(".js-search-form--holder"),
		form: document.querySelector(".js-search-form--form"),
		input: document.querySelector(".js-search-form--input"),
		dialog: document.querySelector(".js-search-form--dialog"),
		open: document.querySelector(".js-search-form--open"),
		close: document.querySelector(".js-search-form--close"),
		header: document.querySelector('.c-tk-header'),
		topBar: document.querySelector('.c-tk-top-bar') || document.querySelector('.c-travelking-top-bar'),
	},

	init() {
		if (!this.selectors.form) {
			return;
		}

		this.onOpenClick = this.onOpenClick.bind(this);
		this.onCloseClick = this.onCloseClick.bind(this);
		this.onAwayClick = this.onAwayClick.bind(this);
		this.onVisualViewportResize = this.onVisualViewportResize.bind(this);

		this.selectors.open.addEventListener("click", this.onOpenClick);
		this.selectors.close.addEventListener("click", this.onCloseClick);

		document.addEventListener("click", this.onAwayClick);
		window.visualViewport.addEventListener(
			"resize",
			this.onVisualViewportResize
		);

		this.events(this.selectors.input);
	},

	events: function (_selector) {
		let self = this;

		if (_selector) {
			let x = _selector;
			let _parentSelector = x.closest('.js-search-form--form');

			x.addEventListener('focus', function (event) {
				if (!self.selectors.holder.classList.contains('is-active')) {
					self.toggle(true);
				}

				let value = this.value;
				self.buildBaseTemplate(_parentSelector);

				self.requestResult(_parentSelector, value).then((result) => {
					self.renderResult(result, _parentSelector), self.errorHandler
				});
			});


			x.addEventListener('focusout', function (event) {
				setTimeout(function () {
					self.destroyBaseTemplate(_parentSelector);
				}, 200);
			});

			x.addEventListener('keyup', function (event) {
				if (event.keyCode !== 13) {
					const {value} = event.target;
					self.selectors.form.classList.toggle('is-typing', value.length > 0);

					self.requestResult(_parentSelector, value).then((result) => {
						self.destroyBaseTemplate(_parentSelector);
						self.buildBaseTemplate(_parentSelector);
						self.renderResult(result, _parentSelector), self.errorHandler
					});
				}
			});
		}
	},

	requestResult: function (_selector, _inputValue) {
		let elRequestURL = _selector.dataset.service;

		let promiseObj = new Promise(function (resolve, reject) {
			let requestURL = _inputValue === '' ? elRequestURL : elRequestURL + '?query=' + _inputValue;
			let request = new XMLHttpRequest();

			request.open('GET', requestURL);
			request.responseType = 'json';
			request.send();
			request.onreadystatechange = function () {
				_selector.classList.add('is-loading');

				if (request.readyState === 4) {
					if (request.status === 200) {
						let response = request.response;
						_selector.classList.remove('is-loading');
						resolve(response);
					} else {
						reject(request.status);
					}
				}
			}
		});

		return promiseObj;
	},

	renderResult: function (_result, _parent) {
		let self = this;

		let result = _result;
		let category = this.parseCategory(result);

		self.removeFromHTML(_parent);
		category.forEach(function (x, i) {
			let currentCategory = x.category;
			let currentCategoryType = x.type;
			let allItems = [];

			result.forEach(function (x, i) {
				if (x.data.category === currentCategory) {
					allItems.push(x);
				}
			})

			self.addToHTML(currentCategory, currentCategoryType, allItems, _parent);
		});
	},

	parseCategory: function (_response) {
		let storedCategory = [];
		let category = [];

		_response.forEach(function (x, i) {
			if (!storedCategory.includes(x.data.category)) {
				storedCategory.push(x.data.category);

				category.push({'category': x.data.category, 'type': x.data.type})
			}
		});

		return category;
	},

	buildBaseTemplate: function (_parent) {
		let searchBox = document.createElement('div');
		searchBox.classList.add('c-tk-search-box');

		let searchBody = document.createElement('div');
		searchBody.classList.add('c-tk-search-form__body');
		searchBody.append(searchBox);

		let searchDialog = document.createElement('div');
		searchDialog.classList.add('c-tk-dialog');
		searchDialog.classList.add('c-tk-dialog--old');
		searchDialog.append(searchBody);

		let mainDialog = document.createElement('div');
		mainDialog.classList.add('c-tk-search-form__dialog');
		mainDialog.classList.add('js-search-form--dialog');
		mainDialog.append(searchDialog);

		if (_parent.querySelector('.c-tk-search-form__dialog') === null) {
			_parent.append(mainDialog);
		}

		this.toggle(true);
	},

	removeFromHTML: function (_parent) {
		let dropdown = _parent.querySelector('.c-tk-search-box');
		if (dropdown) {
			dropdown.innerHTML = '';
		}
	},

	destroyBaseTemplate: function (_parent) {
		let node = _parent.querySelector('.c-tk-search-form__dialog');
		if (node) {
			node.remove();
		}
	},

	addToHTML: function (_categoryName, _categoryType, _items, _parent) {
		let block = _parent.querySelector('.c-tk-search-box');
		let categoryBlock = document.createElement('div');

		if (_categoryType !== 'filteroption' && _categoryType !== 'location' && _categoryType !== 'filter') {
			categoryBlock.classList = 'c-tk-search-box__group';
			block.append(categoryBlock);

			categoryBlock.innerHTML = '<h2 class="c-tk-search-box__heading h4">' + _categoryName + '</h2>';
		}

		if (_categoryType === 'only_hotel') {
			let wrapper = document.createElement('div');
			wrapper.classList = 'c-tk-search-box__cards';
			categoryBlock.append(wrapper);

			_items.forEach(function (x, i) {
				let itemImg = '<figure class="c-tk-simple-deal-card__image"><img src="' + x.data.img + '" width="150" height="100" alt="' + x.value + '"></figure>';
				let itemHeadline = '<h3 class="c-tk-simple-deal-card__heading"><a href="' + x.data.url + '" class="c-tk-simple-deal-card__link u-stretched-link">' + x.value + '</a></h3>';
				let itemLocation = '<p class="c-tk-simple-deal-card__locality">' + x.data.country + '</p>';
				let itemBody = '<article class="c-tk-simple-deal-card group-hover c-tk-simple-deal-card--search">'
					+ itemImg
					+ '<div class="c-tk-simple-deal-card__content">' + itemHeadline + itemLocation + '</div>'
					+ '</article>';

				wrapper.innerHTML += itemBody;
			});

			return;
		}

		if (_categoryType === 'location') {
			categoryBlock.classList = 'c-tk-links-list c-tk-links-list--search';
			block.append(categoryBlock);
			categoryBlock.innerHTML = '<h2 class="c-tk-search-box__heading h4">' + _categoryName + '</h2>';

			let wrapper = document.createElement('ul');
			wrapper.classList = 'c-tk-links-list__list';
			categoryBlock.append(wrapper);

			_items.forEach(function (x, i) {
				wrapper.innerHTML += '<li class="c-tk-links-list__item"><a href="' + x.data.url + '" class="c-tk-links-list__link">' + x.value + '</a></li>'
			});
		} else if (_categoryType === 'hotel' || _categoryType === 'travelcircusevent' || _categoryType === 'cottage') {
			let wrapper = document.createElement('div');
			wrapper.classList = 'c-tk-search-box__cards';
			categoryBlock.append(wrapper);

			_items.forEach(function (x, i) {
				let itemImg = '<figure class="c-tk-simple-deal-card__image"><img src="' + x.data.img + '" width="150" height="100" alt="' + x.value + '"></figure>';
				let itemHeadline = '<h3 class="c-tk-simple-deal-card__heading"><a href="' + x.data.url + '" class="c-tk-simple-deal-card__link u-stretched-link">' + x.value + '</a></h3>';
				let itemLocation = '<p class="c-tk-simple-deal-card__locality">' + x.data.country + '</p>';
				let itemBody = '<article class="c-tk-simple-deal-card group-hover c-tk-simple-deal-card--search">'
					+ itemImg
					+ '<div class="c-tk-simple-deal-card__content">' + itemHeadline + itemLocation + '</div>'
					+ '</article>';

				wrapper.innerHTML += itemBody;
			});
		} else if (_categoryType === 'filter') {
			categoryBlock.classList = 'c-tk-links-list c-tk-links-list--search';
			block.append(categoryBlock);
			categoryBlock.innerHTML = '<h2 class="c-tk-search-box__heading h4">' + _categoryName + '</h2>';

			let wrapper = document.createElement('ul');
			wrapper.classList = 'c-tk-links-list__list';
			categoryBlock.append(wrapper);

			_items.forEach(function (x, i) {
				wrapper.innerHTML += '<li class="c-tk-links-list__item"><a href="' + x.data.url + '" class="c-tk-links-list__link">' + x.value + '</a></li>'
			});
		} else if (_categoryType === 'discount' || _categoryType === 'bestSelling' || _categoryType === 'lastSeen') {
			let wrapper = document.createElement('div');
			wrapper.classList = 'c-tk-search-box__cards';
			categoryBlock.append(wrapper);

			_items.forEach(function (x, i) {
				let itemImg = '<figure class="c-tk-simple-deal-card__image"><img src="' + x.data.img + '" width="150" height="100" alt="' + x.value + '"></figure>';
				let itemHeadline = '<h3 class="c-tk-simple-deal-card__heading"><a href="' + x.data.url + '" class="c-tk-simple-deal-card__link u-stretched-link">' + x.value + '</a></h3>';
				let itemPrice = '<div class="c-tk-simple-deal-card__top"><p class="c-tk-simple-deal-card__price">' + x.data.price + '</p></div>'
				let itemBody = '<article class="c-tk-simple-deal-card group-hover c-tk-simple-deal-card--search">'
					+ itemImg
					+ '<div class="c-tk-simple-deal-card__content">' + itemPrice + itemHeadline + '</div>'
					+ '</article>';

				wrapper.innerHTML += itemBody;
			});
		}

		/* touchpad taps may trigger mousedown instead of click - handling and redirecting to link manually */
		document.querySelectorAll('.c-search-box__link').forEach(e => {
			e.addEventListener('mousedown', function (event) {
				window.location.href = e.getAttribute('href');
			});
		});
	},

	onOpenClick(event) {
		event.preventDefault();

		console.log('open');
		this.toggle(true);
	},

	onCloseClick(event) {
		event.preventDefault();
		this.toggle(false);
	},

	onAwayClick(event) {
		const isActive = this.selectors.holder.classList.contains("is-active");

		if (!isActive) {
			return;
		}

		const isAway =
			!event.target.closest(".js-search-form--open") &&
			!event.target.closest(".js-search-form--holder");

		if (isAway) {
			this.toggle(false);
		}
	},

	onVisualViewportResize(event) {
		document.documentElement.style.setProperty(
			"--visual-viewport-height",
			`${window.visualViewport.height}px`
		);
	},

	focusAndOpenKeyboard() {
		const TRANSITION_DURATION = 300;

		setTimeout(() => {
			this.selectors.input.focus();
		}, TRANSITION_DURATION);
	},

	toggle(state) {
		console.log('toggle', state);
		this.selectors.holder.classList.toggle('is-active', state);
		this.selectors.form.classList.toggle(`is-active`, state);
		this.selectors.header.classList.toggle(`is-open`, state);


		if (state) {
			this.scrollToTop();
			this.focusAndOpenKeyboard();
		}
	},

	scrollToTop() {
		let scrollPosition = 0;

		if (this.selectors.topBar) {
			const rect = this.selectors.topBar.getBoundingClientRect();

			scrollPosition = rect.top + window.scrollY + this.selectors.topBar.clientHeight;
		}

		window.scrollTo({
			top: scrollPosition,
			behavior: 'smooth',
		});
	},
};

SearchForm.init();
